(function () {
  document.querySelectorAll('[data-premium-sticky-bar]').forEach(function (bar) {
    var threshold = Number(bar.dataset.revealAfter || 150);

    function update() {
      if (window.innerWidth >= 768) {
        bar.classList.remove('is-visible');
        return;
      }
      bar.classList.toggle('is-visible', window.scrollY > threshold);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', function () {
      setTimeout(function () {
        if (window.innerWidth < 768) bar.classList.add('is-visible');
      }, 400);
    });
    update();
  });

  document.querySelectorAll('[data-sticky-add-to-cart]').forEach(function (button) {
    button.addEventListener('click', function () {
      var formId = button.dataset.productFormId;
      var form =
        (formId && document.getElementById(formId)) ||
        document.querySelector('.premium-pdp form[data-type="add-to-cart-form"]') ||
        document.querySelector('form[data-type="add-to-cart-form"]') ||
        document.querySelector('.main-product-template form[action*="/cart/add"]');

      if (form) {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      }
    });
  });
})();
